import "./AuthPage.css";

import React from "react";
import Dropzone from "react-dropzone";
import Helmet from "react-helmet";
import BodyClassName from "react-body-classname";
import { connect } from "react-redux";
import { fields } from "../../common/lib/redux-fields";
import { FormattedMessage } from "react-intl";
import { ValidationError } from "../../common/lib/validation";

import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button
} from "reactstrap";

import ButtonWithLoader from "../../browser/components/Form/ButtonWithLoader";

import { signIn, clearAuthError } from "../../common/auth/actions";

class SignInPage extends React.Component {
  constructor() {
    super();

    this.onSubmit = this.onSubmit.bind(this);
  }

  redirect(to) {
    const { router } = this.context;
    if (router) router.transitionTo(to);
  }

  async onSubmit(e) {
    const { fields, appPath } = this.props;
    const { signIn } = this.props;
    e.preventDefault();
    const values = fields.$values();

    const rs = await signIn(values);

    if (rs && rs.status === 200) {
      this.redirect(appPath);
      fields.$reset();
    }
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  render() {
    const { fields, error, loading } = this.props;

    return (
      <div className="auth-page">
        <Helmet title={"Logowanie"} />

        <Container className="splash">
          <Row className="flex-items-xs-center">
            <Col xs="12" sm="12">
              <Row className="flex-items-xs-center logo-row">
                <Col className="text-xs-center" xs="12">
                  <i className="fa fa-heartbeat fa-3x m-b-1 logo" />
                  <div>Wpisz swoje dane</div>
                </Col>
              </Row>
              <Row className="flex-items-xs-center">
                <Col className="text-xs-center" xs="12">
                  <Form onSubmit={this.onSubmit} noValidate>
                    <FormGroup
                      color={
                        ValidationError.isInvalid(error, "usernamePassword") ? (
                          "danger"
                        ) : (
                          ""
                        )
                      }
                      className="flex-items-xs-center"
                      row
                    >
                      <Col sm={11} className="text-xs-left">
                        <Input
                          state={
                            ValidationError.isInvalid(
                              error,
                              "usernamePassword"
                            ) ? (
                              "danger"
                            ) : (
                              ""
                            )
                          }
                          type="email"
                          name="email"
                          placeholder="Email"
                          disabled={loading}
                          onFocus={this.clearError.bind(
                            this,
                            "usernamePassword"
                          )}
                          autoFocus
                          {...fields.username}
                        />
                      </Col>
                    </FormGroup>
                    <FormGroup
                      color={
                        ValidationError.isInvalid(error, "usernamePassword") ? (
                          "danger"
                        ) : (
                          ""
                        )
                      }
                      className="flex-items-xs-center"
                      row
                    >
                      <Col sm={11} className="text-xs-left">
                        <Input
                          state={
                            ValidationError.isInvalid(
                              error,
                              "usernamePassword"
                            ) ? (
                              "danger"
                            ) : (
                              ""
                            )
                          }
                          type="password"
                          name="password"
                          placeholder="Hasło"
                          disabled={loading}
                          onFocus={this.clearError.bind(
                            this,
                            "usernamePassword"
                          )}
                          {...fields.password}
                        />
                        {ValidationError.isInvalid(
                          error,
                          "usernamePassword"
                        ) && (
                          <FormFeedback>
                            Niepoprawny email lub hasło
                          </FormFeedback>
                        )}
                      </Col>
                    </FormGroup>

                    <ButtonWithLoader
                      size="lg"
                      color="primary"
                      isLoading={loading}
                      loadingText="Loguję..."
                      text="Zaloguj się"
                    />
                  </Form>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

SignInPage.contextTypes = {
  router: React.PropTypes.object.isRequired
};

SignInPage = fields(SignInPage, {
  path: "authPage",
  fields: ["username", "password"],
  getInitialState: () => ({
    username: "",
    password: ""
  })
});

export default connect(
  state => ({
    error: state.auth.error,
    loading: state.auth.formLoading,
    fields: state.fields,
    appPath: state.config.appPath
  }),
  { signIn, clearError: clearAuthError }
)(SignInPage);



// WEBPACK FOOTER //
// ./src/browser/auth/SignInPage.js